import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectLogoDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.96929 0.6875V9.61062M8.96929 9.61062L17.3221 14.6541M8.96929 9.61062L0.464844 14.6541",
		stroke: "#1D1D1D",
		strokeWidth: .775923
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.464844 5.15682L9 0.6875L17.5352 5.15682M0.464844 5.15682L9 9.81236M0.464844 5.15682V14.6541L9 19.3097M17.5352 5.15682L9 9.81236M17.5352 5.15682V14.8403L9 19.3097M9 9.81236V19.3097",
		stroke: "#1D1D1D",
		strokeWidth: .775923
	})]
});
export default SvgProjectLogoDefault;
